import { render, staticRenderFns } from "./d2-container-card.vue?vue&type=template&id=48320b4f&"
import script from "./d2-container-card.vue?vue&type=script&lang=js&"
export * from "./d2-container-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48320b4f')) {
      api.createRecord('48320b4f', component.options)
    } else {
      api.reload('48320b4f', component.options)
    }
    module.hot.accept("./d2-container-card.vue?vue&type=template&id=48320b4f&", function () {
      api.rerender('48320b4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-container/components/d2-container-card.vue"
export default component.exports